import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { NotFound } from "../../pages/notfound/NotFound";
import { ForgotPassword } from "../../pages/forgot-password/ForgotPassword";
import { Register } from "../../pages/register/Register";
import { CollectDob } from "../../pages/collectDob/CollectDob";
import { CollectPolicyAndPostcode } from "../../pages/collectPolicyAndPostcode/CollectPolicyAndPostcode";
import { ConfirmForgotPassword } from "../../pages/confirm-forgot-password/ConfirmForgotPassword";
import { LogIn } from "../../pages/login/Login";
import { Verification } from "../../pages/verification/Verification";
import { RegistrationComplete } from "../../pages/registration-complete/RegistrationComplete";
import {PrivateRoute} from "../auth/private-route";
import {ConfirmForgotPasswordCode} from "../../pages/confirm-forgot-password/ConfirmForgotPasswordCode";

export const MyRouter = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route exact path="/">
          <LogIn />
        </Route>
        <Route path="/verification">
          <Verification />
        </Route>
        <Route path="/register">
          <Register />
        </Route>
        <PrivateRoute path="/completeregistration">
          <CollectDob />
        </PrivateRoute>
        <PrivateRoute path="/collectpolicy">
          <CollectPolicyAndPostcode />
        </PrivateRoute>
        <Route path="/forgotpassword">
          <ForgotPassword />
        </Route>
        <Route path="/confirmforgotpassword">
          <ConfirmForgotPassword />
        </Route>
        <Route path="/confirmforgotpasswordcode">
          <ConfirmForgotPasswordCode />
        </Route>
        <Route path="/registrationcomplete">
          <RegistrationComplete />
        </Route>
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
};
